import React, { createContext, useContext, useMemo } from 'react';

import type { Dispatch, ReactNode } from 'react';

import type { ScoutCalendarAction, ScoutCalendarState } from '@/components/ScoutCalendar/types';

interface EventContextValue {
  state: ScoutCalendarState;
  dispatch: Dispatch<ScoutCalendarAction>;
}

const EventContext = createContext<EventContextValue | null>(null);

interface EventProviderProps {
  state: ScoutCalendarState;
  dispatch: Dispatch<ScoutCalendarAction>;
  children: ReactNode;
}

/** Distributes ScoutCalendar reducer state and dispatch via context, eliminating calendarDispatch prop drilling. */
export const EventProvider = ({ state, dispatch, children }: EventProviderProps) => {
  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
};

/** Returns the nearest EventContext value. Must be used inside an EventProvider. */
export const useEventContext = (): EventContextValue => {
  const ctx = useContext(EventContext);
  if (!ctx) throw new Error('useEventContext must be used inside an EventProvider');
  return ctx;
};
